import { render, staticRenderFns } from "./PaapCentralization.vue?vue&type=template&id=1d41643e"
import script from "./PaapCentralization.vue?vue&type=script&lang=js"
export * from "./PaapCentralization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports